import { createBrowserHistory } from 'history';
import {API_URL, BASENAME} from './config';

export const history = createBrowserHistory();
export const getLocationState = () => history.location.state || {};

const defObject = { method: 'push' };
export const navigateTo = (path, { method, ...data } = defObject) => {
  if (path.indexOf(BASENAME) === -1) {
      // Because navigateTo sometimes using relative, sometimes absolute links
      path = BASENAME + path;
  }
  history[method](path, data);
};

export const navigateBack = () => history.goBack();

export const fetchApi = ({ url, ...options }) =>
  fetch(`${API_URL}${url}`, options)
    .then((response) => response.json())
    .then((response) => {
      if (!response.success) {
        return Promise.reject(response.errors || 'Something went wrong');
      }
      return response;
    });

export const promiseAction =
  ({ types, promise, customPayload, params = {} }) =>
  (dispatch, getState) => {
    const [REQUEST, SUCCESS, ERROR] = types;
    dispatch({ type: REQUEST, params });

    return promise(getState)
      .then((response) => {
        const payload = customPayload !== undefined ? customPayload : response;
        dispatch({
          type: SUCCESS,
          payload,
          params,
        });

        return {
          payload,
          success: true,
          params,
        };
      })
      .catch((error) => {
        dispatch({
          type: ERROR,
          error,
          params,
        });

        return Promise.reject({
          error,
          params,
          success: false,
        });
      });
  };
